import { staticBreadcrumbLabelForPath } from "@/lib/breadcrumbRouteLabels";
import { trimText } from "@/lib/utils";

/** Browser tab suffix for local Vite dev versus production UI bundle. */
export function hubEnvironmentTabSuffix(isDev: boolean): string {
  return isDev ? "Dev Hub" : "SGS Hub";
}

/** Standalone routes outside module layouts. */
const STANDALONE_PAGE_LABELS: Readonly<Record<string, string>> = {
  "/sign-in": "Sign in",
  "/access-needed": "Access needed",
  "/personal/chatgpt": "Hub MCP connector",
  "/integrations/mcp": "Hub MCP connector",
  "/integrations/mcp/authorize": "MCP authorize",
};

export function standalonePageLabelForPath(pathname: string): string | null {
  const normalized = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  return STANDALONE_PAGE_LABELS[normalized] ?? null;
}

export function resolveHubPageLabel(input: {
  pathname: string;
  registeredPageLabel: string;
}): string {
  const standalone = standalonePageLabelForPath(input.pathname);
  if (standalone != null) return standalone;

  const registered = trimText(input.registeredPageLabel);
  if (registered.length > 0) return registered;

  return staticBreadcrumbLabelForPath(input.pathname);
}

export interface BuildHubDocumentTitleInput {
  /** Visible page label from breadcrumb registration or route fallback. */
  pageLabel: string;
  /** Integrator module label when inside a module shell. */
  moduleLabel?: string;
  /** When true, use {@link hubEnvironmentTabSuffix}. */
  isDev?: boolean;
}

/**
 * Compose a Chrome-friendly tab title: most specific context first.
 * Example: `GPO-8842 · MRP · SGS Hub`
 */
export function buildHubDocumentTitle(input: BuildHubDocumentTitleInput): string {
  const pageLabel = trimText(input.pageLabel);
  const moduleLabel = trimText(input.moduleLabel);
  const envSuffix = hubEnvironmentTabSuffix(input.isDev ?? false);

  const segments: string[] = [];
  if (pageLabel.length > 0) {
    segments.push(pageLabel);
  }
  if (moduleLabel.length > 0 && pageLabel.localeCompare(moduleLabel, undefined, { sensitivity: "accent" }) !== 0) {
    segments.push(moduleLabel);
  }
  segments.push(envSuffix);
  return segments.join(" · ");
}

export const HUB_FAVICON_LINK_ID = "hub-module-favicon";
export const HUB_APPLE_TOUCH_ICON_LINK_ID = "hub-apple-touch-icon";
